/**
 * Minimal fallback UI rendered when the React tree throws.
 * Used by both the legacy ErrorBoundary and Sentry.ErrorBoundary.
 */
export const ErrorFallback = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-4xl">⚡</p>
      <h1 className="text-xl font-heading font-bold">Algo salió mal</h1>
      <p className="text-sm text-muted-foreground max-w-xs">
        Ocurrió un error inesperado. Recargá la página para continuar.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-6 py-2 rounded-full bg-primary text-primary-foreground font-medium text-sm hover:opacity-90 transition-opacity"
      >
        Recargar
      </button>
    </div>
  );
};

export default ErrorFallback;
